module.exports = __webpack_public_path__ + "static/media/Madfit-8.dc77afa8.jpg";